import { Button, buttonStyle } from 'components/button/Button';
import { defaultButtonStyle } from 'components/button/DefaultButton';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const LinkButton = styled.a`
    ${buttonStyle}
    ${defaultButtonStyle}

    display: inline-block;
    text-decoration: none;
`;

export const MenuLink = styled(NavLink)<{ $padding?: string }>`
    padding-left: ${({ $padding }) => $padding || '1.5rem'};
    padding-right: ${({ $padding }) => $padding || '1.5rem'};
    display: flex;
    align-items: center;
    height: 100%;

    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: transparent;

    color: ${tokens.icon.actionActive};

    &:hover {
        border-bottom-color: ${tokens.nav.border};
        color: ${tokens.icon.actionHover};
    }
`;

export const MenuButton = styled(Button)<{ $active?: boolean }>`
    width: 4.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    color: ${(props) =>
        props.$active ? tokens.icon.actionSelected : tokens.icon.actionActive};

    border-radius: 0;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${(props) =>
        props.$active ? tokens.primary.default : 'transparent'};

    &:hover {
        border-bottom-color: ${(props) =>
            props.$active ? tokens.primary.default : tokens.nav.border};
        color: ${(props) =>
            props.$active ? tokens.icon.actionSelected : tokens.icon.actionHover};
    }

    &:active {
        border-bottom-color: ${tokens.primary.dark};
        color: ${tokens.icon.actionSelected};
    }
`;
